<template>
  <div class="trainer-manager">
    <sub-navigation :items="menuItems"/>

    <container>
      <router-view></router-view>
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'
import SubNavigation from '@/components/SubNavigation'
import PageTitle from '@/components/PageTitle'
import VButton from '@/components/Forms/VButton'

export default {
  name: 'TrainerManager',
  data: () => ({
    menuItems: [
      { to: '/admin/trainers', title: 'All Trainers' },
      { to: '/admin/trainers/add', title: 'Add Trainer' }
    ]
  }),
   
    created() {
        if(this.$auth.user().id != 287 && this.$auth.user().id!=2977 && this.$auth.user().id!=2750 && this.$auth.user().id != 1260 && this.$auth.user().id != 6 && this.$auth.user().id!= 14 && this.$auth.user().id!= 11){
            this.$router.push({ path: '/403' })
        }
    },
  components: {
    Container,
    PageTitle,
    VButton,
    SubNavigation
  }
}
</script>

<style lang="stylus" scoped>
  .container
    margin 20px auto 0
</style>



// WEBPACK FOOTER //
// TrainerManager.vue?1452f559